export default function useMacFontScale() {
  return 1;
}
